export const INITIAL_POSTAL_TYPE = [
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ORDERED_POSTCARD',
    value: 'ordered_postcard' as 'ordered_postcard',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ORDERED_LETTER',
    value: 'ordered_letter' as 'ordered_letter',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ORDERED_PARCEL_POST',
    value: 'ordered_parcel_post' as 'ordered_parcel_post',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ORDERED_SMALL_PACKAGE',
    value: 'ordered_small_package' as 'ordered_small_package',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.LETTER_DECLARE_VALUE',
    value: 'letter_declare_value' as 'letter_declare_value',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.SMALL_PACKAGE_DECLARE_VALUE',
    value: 'small_package_declare_value' as 'small_package_declare_value',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.PACKAGE',
    value: 'package' as 'package',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.PACKAGE_DECLARE_VALUE',
    value: 'package_declare_value' as 'package_declare_value',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.EMS',
    value: 'ems' as 'ems',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ECOMMERCE_ECONOM',
    value: 'ecommerce_economical' as 'ecommerce_economical',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ECOMMERCE_STANDARD',
    value: 'ecommerce_standard' as 'ecommerce_standard',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ECOMMERCE_ELITE',
    value: 'ecommerce_elite' as 'ecommerce_elite',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ECOMMERCE_EXPRESS',
    value: 'ecommerce_express' as 'ecommerce_express',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ECOMMERCE_LIGHT',
    value: 'ecommerce_light' as 'ecommerce_light',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ECOMMERCE_OPTIMA',
    value: 'ecommerce_optima' as 'ecommerce_optima',
  },
];

export let POSTAL_TYPE = Array.from(INITIAL_POSTAL_TYPE);

export function setPostalTypes(postalTypes: typeof POSTAL_TYPE) {
  POSTAL_TYPE = postalTypes;
}

export function resetPostalTypes() {
  POSTAL_TYPE = Array.from(INITIAL_POSTAL_TYPE);
}

export type PostalType = (typeof POSTAL_TYPE)[number]['value'];
export const POSTAL_TYPE_MAP = new Map<string, string>(
  POSTAL_TYPE.map((item) => [item.value, item.label]) as any
);

// сейчас нет инфы
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ORDERED_SM_PACKAGE_INT',
//   value: 'ordered_small_package_international',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.PACKAGE_INT',
//   value: 'package_international',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ORDERED_BAG_INT',
//   value: 'ordered_bag_international',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.SECOGRAM',
//   value: 'secogram',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.LETTER_DECLARED_VALUE_INT',
//   value: 'letter_declare_value_international',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ORDERED_LETTER_INT',
//   value: 'ordered_letter_international',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.GOV_LETTER',
//   value: 'government_letter',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.EMS_INT',
//   value: 'ems_international',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.PACKAGE_DECLARED_VALUE_INT',
//   value: 'package_declare_value_international',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.INT_SECOGRAM',
//   value: 'secogram_international',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.GOV_POSTCARD',
//   value: 'government_postcard',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.GOV_PARCEL_POST',
//   value: 'government_parcel_post',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.GOV_SMALL_PACKAGE',
//   value: 'government_small_package',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.GOV_SECOGRAM',
//   value: 'government_secogram',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ORDERED_POSTCARD_INT',
//   value: 'ordered_postcard_international',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ORDERED_PARCEL_INT',
//   value: 'ordered_parcel_post_international',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.PACKAGE_SIMPLE',
//   value: 'package_simple',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.INT_SHIPPING_WITH_TRACKING',
//   value: 'international_shipping_with_tracking',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.PARTIAL_TRACKING_SIMPLE_INT',
//   value: 'partial_tracking_simple_international',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.PACKAGE_PAYED',
//   value: 'package_payed',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.SMALL_PACKAGE_PAYED',
//   value: 'small_package_payed',
// },
// {
//   label: 'BATCH_MAILING.BATCHES_TAB.METADATA.ORDERED_LETTER_HYBRID',
//   value: 'ordered_letter_hybrid',
// },
